import React, { Component } from "react";
import { Collapse, Container } from "reactstrap";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import withRouter from "../Common/withRouter";
import {
    DATABASE_CLIENT_EDIT,
    DATABASE_CLIENT_FORM,
    DATABASE_CLIENT_PAGE,
    DATABASE_VEHICULE_EDIT,
    DATABASE_VEHICULE_FORM,
    DATABASE_VEHICULE_MANAGER_PAGE,
    DATABASE_VEHICULE_PAGE,
    ENCHERES_PAGE,
    FERRAILLEURS_ENCHERES_VISIBLES_PAGE,
    FERRAILLEURS_MES_ACHATS_PAGE,
    FERRAILLEURS_TERMS_PAGE,
    MODULE_SELECTOR_PAGE,
    PRAMETRAGE_PAGE,
    RESEAU_PAGE,
    VHU_BID_OFFERS_PAGE,
    VHU_EXPIRED_LOTS_PAGE,
    VHU_LOTS_PAGE,
    VVINAL_PAGE,
} from "../../routes/routeConstants";
import {
    ASSURANCE_ROLES,
    EXPERT_ROLES,
    FERRAILLEUR_ROLES,
    getCurrentRoles,
    hasAnyRole,
} from "../../helpers/roles";

const stripRouteParam = (path) => path.replace("/:id", "");

const moduleMenus = [
    {
        id: "vehicules",
        roles: [...EXPERT_ROLES, ...ASSURANCE_ROLES],
        match: [DATABASE_VEHICULE_PAGE, DATABASE_VEHICULE_FORM, DATABASE_VEHICULE_MANAGER_PAGE, stripRouteParam(DATABASE_VEHICULE_EDIT)],
        items: [
            { label: "Véhicules", icon: "ri-car-line", path: DATABASE_VEHICULE_PAGE, match: [DATABASE_VEHICULE_PAGE], roles: [...EXPERT_ROLES, ...ASSURANCE_ROLES] },
            { label: "Créer vehicule", icon: "ri-add-circle-line", path: DATABASE_VEHICULE_MANAGER_PAGE, match: [DATABASE_VEHICULE_MANAGER_PAGE, DATABASE_VEHICULE_FORM], roles: EXPERT_ROLES },
            { label: "Edition", icon: "ri-dashboard-2-line", path: DATABASE_VEHICULE_PAGE, match: [stripRouteParam(DATABASE_VEHICULE_EDIT)], roles: EXPERT_ROLES },
        ],
    },
    {
        id: "clients",
        roles: [...EXPERT_ROLES, ...ASSURANCE_ROLES],
        match: [DATABASE_CLIENT_PAGE, DATABASE_CLIENT_FORM, stripRouteParam(DATABASE_CLIENT_EDIT)],
        items: [
            { label: "Clients", icon: "ri-user-3-line", path: DATABASE_CLIENT_PAGE, match: [DATABASE_CLIENT_PAGE], roles: [...EXPERT_ROLES, ...ASSURANCE_ROLES] },
            { label: "Nouveau client", icon: "ri-user-add-line", path: DATABASE_CLIENT_FORM, match: [DATABASE_CLIENT_FORM, stripRouteParam(DATABASE_CLIENT_EDIT)], roles: EXPERT_ROLES },
        ],
    },
    {
        id: "vvinal",
        roles: EXPERT_ROLES,
        match: [VVINAL_PAGE],
        items: [
            { label: "Valeur vénale", icon: "ri-currency-line", path: VVINAL_PAGE, match: [VVINAL_PAGE], roles: EXPERT_ROLES },
        ],
    },
    {
        id: "parametrage",
        roles: EXPERT_ROLES,
        match: [PRAMETRAGE_PAGE],
        items: [
            { label: "Parametrage", icon: "ri-settings-line", path: PRAMETRAGE_PAGE, match: [PRAMETRAGE_PAGE], roles: EXPERT_ROLES },
        ],
    },
    {
        id: "encheres",
        roles: EXPERT_ROLES,
        match: [ENCHERES_PAGE, VHU_LOTS_PAGE, VHU_EXPIRED_LOTS_PAGE, VHU_BID_OFFERS_PAGE],
        items: [
            { label: "Lots VHU", icon: "ri-recycle-line", path: VHU_LOTS_PAGE, match: [VHU_LOTS_PAGE], roles: EXPERT_ROLES },
            { label: "Enchères expirées", icon: "ri-time-line", path: VHU_EXPIRED_LOTS_PAGE, match: [VHU_EXPIRED_LOTS_PAGE], roles: EXPERT_ROLES },
            { label: "Offres VHU", icon: "ri-auction-line", path: VHU_BID_OFFERS_PAGE, match: [VHU_BID_OFFERS_PAGE], roles: EXPERT_ROLES },
        ],
    },
    {
        id: "ferrailleurs",
        roles: FERRAILLEUR_ROLES,
        match: [FERRAILLEURS_ENCHERES_VISIBLES_PAGE, FERRAILLEURS_MES_ACHATS_PAGE, FERRAILLEURS_TERMS_PAGE],
        items: [
            { label: "Lots autorises", icon: "ri-eye-line", path: FERRAILLEURS_ENCHERES_VISIBLES_PAGE, match: [FERRAILLEURS_ENCHERES_VISIBLES_PAGE], roles: FERRAILLEUR_ROLES },
            { label: "Mes achats", icon: "ri-shopping-bag-3-line", path: FERRAILLEURS_MES_ACHATS_PAGE, match: [FERRAILLEURS_MES_ACHATS_PAGE], roles: FERRAILLEUR_ROLES },
            { label: "Termes & Conditions", icon: "ri-file-list-3-line", path: FERRAILLEURS_TERMS_PAGE, match: [FERRAILLEURS_TERMS_PAGE], roles: FERRAILLEUR_ROLES },
        ],
    },
    {
        id: "reseau",
        roles: EXPERT_ROLES,
        match: [RESEAU_PAGE],
        items: [
            { label: "Groupes et ferrailleurs", icon: "ri-team-line", path: RESEAU_PAGE, match: [RESEAU_PAGE], roles: EXPERT_ROLES },
        ],
    },
];

const matchesPath = (pathname, paths = []) => paths.some((path) => pathname === path || pathname.startsWith(`${path}/`));
const matchesMenuItem = (pathname, paths = []) => paths.some((path) => pathname === path || (path.endsWith("/edit") && pathname.startsWith(`${path}/`)));

const getCurrentModuleMenu = (pathname, roles) => {
    const allowedMenus = moduleMenus.filter((module) => hasAnyRole(roles, module.roles));
    return allowedMenus.find((module) => matchesPath(pathname, module.match)) || allowedMenus[0] || moduleMenus[0];
};

class Navbar extends Component {
    componentDidMount() {
        const ul = document.getElementById("navigation");
        const items = ul ? ul.getElementsByTagName("a") : [];
        let matchingMenuItem = null;
        for (let i = 0; i < items.length; ++i) {
            if (this.props.router.location.pathname === items[i].pathname) {
                matchingMenuItem = items[i];
                break;
            }
        }
        if (matchingMenuItem) {
            this.activateParentDropdown(matchingMenuItem);
        }
    }

    activateParentDropdown = (item) => {
        item.classList.add("active");
        let parent = item.parentElement;
        while (parent) {
            parent.classList.add("active");
            parent = parent.parentElement;
        }
        return false;
    };

    render() {
        const pathname = this.props.router.location.pathname;
        const roles = getCurrentRoles();
        const currentModule = getCurrentModuleMenu(pathname, roles);
        const currentItems = (currentModule.items || []).filter((item) => hasAnyRole(roles, item.roles));

        return (
            <React.Fragment>
                <div className="topnav topnav-enhanced">
                    <Container fluid>
                        <nav className="navbar navbar-light navbar-expand-lg topnav-menu topnav-menu-enhanced" id="navigation">
                            <Collapse isOpen={this.props.menuOpen} className="navbar-collapse navbar-collapse-enhanced" id="topnav-menu-content">
                                <ul className="navbar-nav navbar-nav-enhanced">
                                    <li className="nav-item nav-item-enhanced">
                                        <Link className="nav-link nav-link-enhanced" to={MODULE_SELECTOR_PAGE}>
                                            <i className="ri-arrow-left-line me-2 nav-icon"></i>
                                            <span className="nav-label">Retour aux modules</span>
                                        </Link>
                                    </li>

                                    {currentItems.map((item) => {
                                        const isActive = matchesMenuItem(pathname, item.match);
                                        return (
                                            <li className="nav-item nav-item-enhanced" key={item.path}>
                                                <Link className={`nav-link nav-link-enhanced${isActive ? " active" : ""}`} to={item.path}>
                                                    <i className={`${item.icon} me-2 nav-icon`}></i>
                                                    <span className="nav-label">{item.label}</span>
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </Collapse>
                        </nav>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = (state) => {
    const { leftSideBarType, leftSideBarTheme } = state.Layout;
    return { leftSideBarType, leftSideBarTheme };
};

export default withRouter(connect(mapStatetoProps, {})(withTranslation()(Navbar)));
